import { motion } from "framer-motion";
import { Chapter, MaskedLine, Reveal } from "../components/motion";
import { config } from "../config/siteConfig";

const Founder = () => (
  <section
    id="founder"
    data-testid="founder-section"
    className="bg-white text-[#08162B] py-24 lg:py-36"
  >
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <Chapter index="01" label="The Author" />

      <div className="mt-14 grid lg:grid-cols-12 gap-12 lg:gap-16">
        <div className="lg:col-span-5">
          <Reveal>
            <div
              data-testid="author-portrait-frame"
              className="relative aspect-[4/5] bg-[#08162B] overflow-hidden"
            >
              {config.author.photo ? (
                <>
                  <motion.img
                    src={config.author.photo}
                    alt={config.author.photoAlt}
                    loading="lazy"
                    data-testid="author-portrait-image"
                    initial={{ opacity: 0, scale: 1.06 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    viewport={{ once: true, amount: 0.3 }}
                    transition={{ duration: 1.4, ease: [0.16, 1, 0.3, 1] }}
                    className="absolute inset-0 h-full w-full object-cover object-[50%_20%]"
                  />
                  <div className="absolute inset-x-0 bottom-0 h-1/3 bg-gradient-to-t from-[#08162B]/80 to-transparent" />
                  <div className="absolute left-6 right-6 top-6 h-px bg-[#D4AF37]/70" />
                </>
              ) : (
                <div className="absolute inset-0 flex flex-col items-center justify-center gap-6 p-10 text-center">
                  <span className="font-display text-7xl text-white/15">ADI</span>
                  <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-white/40 leading-relaxed">
                    Portrait of Anthony Douglas-Izear
                    <br />
                    Photograph forthcoming
                  </span>
                </div>
              )}
              <div className="absolute inset-0 border border-white/10 pointer-events-none" />
            </div>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="mt-5 font-mono text-[11px] uppercase tracking-[0.25em] text-[#08162B]">
              {config.author.name}
            </p>
            <p className="mt-1 font-mono text-[10px] uppercase tracking-[0.2em] text-[#5A6E85]">
              {config.author.role}
            </p>
          </Reveal>
        </div>

        <div className="lg:col-span-7">
          <h2 className="font-display tracking-[0.02em] leading-[1.05] text-[clamp(2rem,4.5vw,3.75rem)]">
            <MaskedLine delay={0.1}>I DIDN'T START WITH A BLUEPRINT.</MaskedLine>
          </h2>
          <p className="mt-4 font-sans font-extrabold uppercase tracking-tight text-2xl sm:text-4xl text-[#08162B]/35">
            <MaskedLine delay={0.25}>I HAD TO BUILD ONE.</MaskedLine>
          </p>

          <div className="mt-10 space-y-5 max-w-2xl">
            {config.founder.paragraphs.map((para, i) => (
              <Reveal key={i} delay={0.06 * i} y={18}>
                <p
                  className={`leading-relaxed ${
                    para.emphasis
                      ? "font-condensed text-xl sm:text-2xl text-[#08162B]"
                      : "text-lg text-[#5A6E85]"
                  }`}
                >
                  {para.text}
                </p>
              </Reveal>
            ))}
          </div>

          <Reveal delay={0.15} className="mt-12">
            <blockquote
              data-testid="founder-pull-quote"
              className="relative border-l-4 border-[#D4AF37] pl-6 sm:pl-10 py-2"
            >
              {config.founder.lesson.map((line, i) => (
                <p
                  key={line}
                  className={`font-display tracking-[0.02em] leading-[1.1] text-[clamp(1.6rem,3.5vw,2.75rem)] ${
                    i === 0 ? "text-[#08162B]/40" : "text-[#08162B]"
                  }`}
                >
                  {line}
                </p>
              ))}
            </blockquote>
          </Reveal>

          <Reveal delay={0.2} className="mt-12">
            <p className="text-lg text-[#5A6E85] max-w-2xl">{config.founder.bridge}</p>
            <p
              data-testid="founder-method-line"
              className="mt-5 font-sans font-extrabold uppercase tracking-tight text-2xl sm:text-4xl text-[#08162B]"
            >
              {config.founder.method}
            </p>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);

export default Founder;
